<template>
  <div class="unit__items">
    <div class="unit__title">
      <div class="icon-avatar justify-space-between" v-if="formAbove">
        <slot name="icon"></slot>
        <div>
          <h2>{{ title }}</h2>
          <div v-html="description" v-if="description"></div>
        </div>
        <v-btn
          @click="add"
          class="ma-1 amber"
          fab
          small
          light
          :disabled="maxItems"
        >
          <v-icon>mdi-plus</v-icon></v-btn
        >
      </div>

      <div
        class="unit__icon mt-4"
        :style="{
          backgroundImage: `url(${bgSrc})`,
          backgroundPosition: `${vAlign} ${hAlign}`,
          backgroundSize: `${size}`,
        }"
      >
        <div v-if="!formAbove">
          <h2>{{ title }}</h2>
          <div
            v-html="description"
            v-if="description"
            class="break-spaces"
          ></div>
        </div>
        <div class="unit__form" v-if="!formAbove">
          <v-textarea
            :color="color"
            v-model="item.title"
            :rows="1"
            :autoGrow="true"
            class="ma-0"
            :hide-details="true"
            v-if="!maxItems"
          />
          <v-btn
            :color="color"
            class="ma-0 ml-2"
            @click="add"
            :disabled="maxItems"
            light
            >Add</v-btn
          >
        </div>
        <div class="unit__icon-overlay">
          <div class="unit__icon-inner">
            <draggable
              class="inner mt-5"
              :list="items"
              group="order"
              @start="startDrag()"
              @end="endDrag()"
              :ref="name"
              :id="name"
            >
              <div
                v-for="(item, index) in items"
                :key="`unit-${index}`"
                class="item"
                :data-id="`${Math.round(new Date().getTime() / 1000)}`"
                :class="{ inactive: checkEditIndex(index) }"
              >
                <v-textarea
                  :color="color"
                  v-model="item.title"
                  :rows="1"
                  :autoGrow="true"
                  v-if="editMode"
                  :hide-details="true"
                  class="item__edit"
                />
                <p v-else class="break-spaces">{{ item.title }}</p>
                <div class="icons">
                  <v-icon @click="edit(index)" class="white--text ma-1"
                    >mdi-pencil</v-icon
                  >
                  <v-icon @click="remove(index)" class="white--text ma-1"
                    >mdi-delete-forever</v-icon
                  >
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="deleteMode" light>
        <v-card-title>
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeItem"
            >Delete</v-btn
          >
          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card v-else-if="editMode" light>
        <v-card-title class="mb-0 pb-0">
          {{ title }}
        </v-card-title>
        <v-card-text class="">
          <p class="body-1" v-html="description"></p>
          <p class="small ma-0 pa-0">Type in the box below</p>
          <v-textarea
            color="amber"
            v-model="item.title"
            :rows="4"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-btn light color="amber mr-5" class="mt-2" @click="editItem"
            >Update</v-btn
          >
          <v-btn light color="white" class="mt-2" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card light v-else>
        <v-card-title class="mb-0 pb-0">
          {{ title }}
        </v-card-title>
        <v-card-text class="">
          <p class="body-1" v-html="description"></p>
          <p class="small ma-0 pa-0">Type in the box below</p>
          <v-textarea
            color="amber"
            v-model="item.title"
            :rows="4"
            :autoGrow="true"
            :hide-details="false"
            class="ma-0 pa-0"
          />
          <v-btn light color="amber mr-5" class="mt-2" @click="addItem"
            >Add</v-btn
          >
          <v-btn light color="white" class="mt-2" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "UnitItemsIcon",
  data() {
    return {
      items: this.value,
      item: {},
      currIndex: null,
      refs: null,
      fields: [],
      editMode: false,
      editIndex: null,
      deleteMode: false,
      deleteId: null,
      dialog: false,
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    description: String,
    color: String,
    limit: {
      type: Number,
      default: 3,
    },
    svg: {
      type: String,
      default: "",
    },
    vAlign: {
      type: String,
      default: "center",
    },
    hAlign: {
      type: String,
      default: "center",
    },
    size: {
      type: String,
      default: "contain",
    },
    bgMode: {
      type: Boolean,
      default: false,
    },
    formAbove: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    draggable,
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
  computed: {
    bgSrc() {
      if (this.svg) {
        return require(`@/assets/${this.svg}`);
      } else {
        return "";
      }
    },
    maxItems() {
      if (this.limit) {
        return (this.items && this.items.length) >= this.limit ? true : false;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    checkField(val) {
      return val ? val : "";
    },
    add() {
      this.dialog = true;
    },
    addItem() {
      let item = {
        index: this.items.length,
        title: this.checkField(this.item.title),
        description: this.checkField(this.item.description),
        id: this.items.length,
        type: "content",
      };
      this.items.push(item);
      this.item = {};
      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.dialog = false;
      this.$emit("autosave");
    },
    edit(index) {
      this.editMode = !this.editMode;
      this.dialog = true;
      this.editIndex = index;
      this.item = this.items[this.editIndex];
    },
    editItem() {
      let item = {
        index: this.editIndex,
        title: this.checkField(this.item.title),
        description: this.checkField(this.item.description),
        id: this.editIndex,
        type: "content",
      };
      this.$set(this.items, this.editIndex, item);
      this.item = {};
      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.dialog = false;
      this.$emit("autosave");
    },
    remove(index) {
      this.deleteMode = true;
      this.deleteId = index;
      this.dialog = true;
    },
    removeItem() {
      this.items.splice(this.deleteId, 1);
      this.cancel();
      this.$emit("autosave");
    },
    cancel() {
      this.dialog = false;
      this.deleteId = null;
      this.deleteMode = false;
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        console.log(item);
        let indexOfItem = this.items.indexOf(item);
        item.index = count;
        vm.$set(vm.items, indexOfItem, item);
        count++;
      });
      this.dragging = false;
      this.$emit("autosave");
    },
    checkEditIndex(index) {
      if (this.editMode) {
        return index == this.editIndex ? false : true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.unit {
  &__title {
    h2 {
      color: white;
    }
  }
}
.unit-absolute {
  position: absolute;
}
.unit__form {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
}
.icon-avatar {
  display: flex;
  align-items: center;
  img {
    width: 100px;
    height: auto;
    padding-right: 1rem;
  }
}
.unit__items {
  .item {
    padding: 0rem 1rem 0 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0.5rem 0;
    background: none;
    border-bottom: 1px dotted white;
    border-radius: 0px;
    color: white;
    width: 100%;
    p {
      text-align: left;
      font-size: 1.2rem;
      line-height: 1.4;
      margin: 0;
      padding: 0;
      font-weight: 300;
    }
    .icons {
      width: 50px;
      padding: 0 10px;
      display: flex;
    }
    &__edit {
      text-align: left;
      font-size: 1.3rem;
      line-height: 1.4;
      margin: 0;
      padding: 0;
      font-weight: 300;
    }
  }
}
.inactive {
  // opacity: 0;
  visibility: hidden;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
.unit__icon {
  position: relative;
  min-height: 500px;
  background-position: center;
  object-fit: contain;
}
.unit__icon-overlay {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  display: flex;
  align-items: center;
  padding: 0rem;
  h2 {
    color: black;
    font-size: 2rem;
    margin: 0;
    padding: 0;
    line-height: 0;
  }
}
.unit__icon-inner {
  width: 100%;
}
.unit__light {
  width: 400px;
  height: 400px;
  // padding-bottom: 100%;
  border-radius: 50%;
  margin: 0.5rem auto;
  background: white;
  position: relative;

  .unit__light-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  p {
    color: white;
    font-weight: 600;
    margin: 0;
    line-height: 1.4;
    text-transform: uppercase;
  }
  h2 {
    text-transform: uppercase;
    color: white;
    font-size: 3rem;
    line-height: 3rem;
  }
}
.full-height {
  height: 80vh;
  .unit__icon {
    height: 80vh;
  }
}
</style>
